var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"19","height":"12.3333","rx":"2.5","key":0}),React.createElement("path",{"id":"timeline","d":"M8 6.66667V9.00973C8 9.1584 8.15646 9.2551 8.28944 9.18861L12.9756 6.84555C13.123 6.77185 13.123 6.56149 12.9756 6.48778L8.28944 4.14472C8.15646 4.07823 8 4.17493 8 4.32361V6.66667Z","fill":"#636363","key":1})]);
}

Video.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = Video;

Video.default = Video;
